/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CheckSquareCutIcon16Light } from './CheckSquareCutIcon16Light';
import { CheckSquareCutIcon16Regular } from './CheckSquareCutIcon16Regular';
import { CheckSquareCutIcon16Solid } from './CheckSquareCutIcon16Solid';
import { CheckSquareCutIcon20Light } from './CheckSquareCutIcon20Light';
import { CheckSquareCutIcon20Regular } from './CheckSquareCutIcon20Regular';
import { CheckSquareCutIcon20Solid } from './CheckSquareCutIcon20Solid';
import { CheckSquareCutIcon24Regular } from './CheckSquareCutIcon24Regular';
import { CheckSquareCutIcon24Solid } from './CheckSquareCutIcon24Solid';
import { CheckSquareCutIcon32Regular } from './CheckSquareCutIcon32Regular';
import { CheckSquareCutIcon64Regular } from './CheckSquareCutIcon64Regular';
var sizes = {
    16: {
        light: CheckSquareCutIcon16Light,
        regular: CheckSquareCutIcon16Regular,
        solid: CheckSquareCutIcon16Solid,
    },
    20: {
        light: CheckSquareCutIcon20Light,
        regular: CheckSquareCutIcon20Regular,
        solid: CheckSquareCutIcon20Solid,
    },
    24: {
        regular: CheckSquareCutIcon24Regular,
        solid: CheckSquareCutIcon24Solid,
    },
    32: {
        regular: CheckSquareCutIcon32Regular,
    },
    64: {
        regular: CheckSquareCutIcon64Regular,
    },
};
export var CheckSquareCutIcon = forwardRef('CheckSquareCutIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
